import { state } from "state";
import { Controller } from "stimulus";

export default class extends Controller {
  static values = { ids: Array };

  connect() {
    state.setVisiblePlantings(this.idsValue);
  }
}
